import type { StripeConnectGetLoginLinkResponse } from "wagAPI";
import type { StripeConnectGetLoginLinkParsedResponse } from "webApp";
export const stripeConnectRedirectLinkResponseParser = (response: StripeConnectGetLoginLinkResponse): StripeConnectGetLoginLinkParsedResponse => ({
  accountLinkUrl: response.account_link_url
});
export default stripeConnectRedirectLinkResponseParser;